import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Acceso — Asistentes Virtual";
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  const inputCls =
    "w-full rounded-[9px] border border-[#D3D1C7] bg-white px-3.5 py-2.5 text-[14px] text-brand-ink outline-none transition-colors duration-200 focus:border-brand-indigo focus:ring-2 focus:ring-brand-indigo/20";

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-bgAlt px-6" data-testid="login-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-sm rounded-[14px] border border-brand-line bg-white p-8 shadow-[0_16px_40px_rgba(31,41,55,0.06)]"
      >
        <Logo size={28} />
        <h1 className="mt-6 text-2xl font-medium tracking-tight text-brand-ink">Panel de administración</h1>
        <p className="mt-1.5 text-[14px] text-[#5F5E5A]">Accede para ver las solicitudes recibidas.</p>

        <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="login-form">
          <div>
            <label className="mb-1.5 block text-[13px] text-[#5F5E5A]">Correo</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className={inputCls} data-testid="login-email" />
          </div>
          <div>
            <label className="mb-1.5 block text-[13px] text-[#5F5E5A]">Contraseña</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className={inputCls} data-testid="login-password" />
          </div>
          {error && (
            <p className="text-[13px] text-red-600" data-testid="login-error">{error}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full rounded-[10px] bg-brand-indigo py-3 text-[15px] font-medium text-white shadow-[0_8px_24px_rgba(79,70,229,0.3)] transition-transform duration-200 hover:-translate-y-0.5 disabled:opacity-60"
          >
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
